<div class="row row-no-margin-nowrap ">
  <figure  class="c-brand">
    <a [routerLink]="'/'+urlHome" alt="Ir a Inicio Portal transaccional empresas">
      <img appDebounceClick  id="Header_PTEC-Logo" src="./assets/images/Logotipo.svg"
      alt="Logo de Colsubsidio" />
    </a>
  </figure>

  <div class="hide-up--md first-xs" (click)="clickToggle($event)">
    <img class="icon-avatar" src="./assets/icons/icon-avatar.svg" alt="Imagén de avatar">
  </div>

  <div class="action-mob hide-up--md">
    <button  type="button" class="action-mob_btn color-white" (click)="toogleMenu()">
      <em class="material-icons" aria-hidden="true">
        menu
      </em>
    </button>
  </div>

  <div  class="navbar-item d-flex middle-xs hide-down--md">
    <div class="navbar-item d-flex middle-xs hide-down--md">
      <app-notify class="navbar-subitem"></app-notify>
    </div>
    <app-nav-user class="c-avatar navbar-subitem d-flex middle-xs" (overlayActive)="dropDown($event)"></app-nav-user>

  </div>

</div>

<app-accessibility-items></app-accessibility-items>


<div class="c-dropdown shadow-item animated fadeInDown t-20" [ngClass]="{ 'c-dropdown--active': modal }">
  <h3 class="title section">
    Bienvenido
    <em class="material-icons icon-close" (click)="clickToggle($event)" aria-hidden="true">
      close
    </em>
  </h3>

  <div class="text">
    {{ userLoggin.firstName.toLowerCase() }} {{ userLoggin.lastName.toLowerCase() }} /
    <span *ngIf="companyData === null">
      <span *ngIf="$companyData | async as dataCompany">{{ dataCompany.nombre.toLowerCase() }}</span>
    </span>

    <span *ngIf="companyData !== null">
      <span >{{ companyData.nombre.toLowerCase() }}</span>
    </span>
  </div>

</div>

<div class="menu" [ngClass]="{ 'modal-show': menu, 'modal-hidden': !menu }">
  <div class="bg-blue-dark color-white text-center menu-header">
    Menú

    <em aria-hidden="true"  class="material-icons menu-close" (click)="toogleMenu()">
      close
    </em>
  </div>

  <ul class="c-nav_list">
    <li class="c-nav_item pb-24">

      <button type="button"
      appDebounceClick id="Header_PTEC-Menu Home" title="Inicio"
      [routerLink]="'/'+urlHome"
        class="c-nav_link color-blue-dark"
        (click)="toogleMenu()">
        <em class="material-icons" aria-hidden="true">
          home
        </em>
        Inicio
      </button>
    </li>

    <li class="c-nav_item pb-24">
      <a appDebounceClick id="Header_PTEC-Menu InfoBussiness" title="Información de Empresa" [routerLink]="'/'+urlBusinessInformation"
         class="c-nav_link color-blue-dark" (click)="toogleMenu()">
        <em class="material-icons" aria-hidden="true">work</em>
        Información de Empresa
      </a>
    </li>

    <li class="c-nav_item pb-24">
      <a appDebounceClick id="Header_PTEC-Menu InfoWorker" title="Información de Trabajadores"
        [routerLink]="'/'+urlWorkersInformation"  class="c-nav_link color-blue-dark" (click)="toogleMenu()">
        <em class="material-icons" aria-hidden="true">account_box</em>
        Información de Trabajadores
      </a>
    </li>

    <li class="c-nav_item pb-24">
      <a appDebounceClick id="Header_PTEC-Menu InfoAffiliation" title="Afiliación" [routerLink]="'/'+urlAffiliation"
         class="c-nav_link color-blue-dark" (click)="toogleMenu()">
        <em class="material-icons" aria-hidden="true">supervisor_account</em>
        Afiliación
      </a>
    </li>

    <li class="c-nav_item pb-24">
      <a appDebounceClick id="Header_PTEC-Menu InfoAffiliation" title="Afiliación" [routerLink]="'/'+urlRetiro"
         class="c-nav_link color-blue-dark" (click)="toogleMenu()">
        <em class="material-icons" aria-hidden="true">supervisor_account</em>
        Retiro
      </a>
    </li>

    <li class="c-nav_item pb-24">
      <a appDebounceClick
      id="PTEC-Menu_Header CustomerService" title="Servicio al cliente"
      [routerLink]="'/'+urlPqrs"
        class="c-nav_link color-blue-dark"
        (click)="toogleMenu()"
      ><em class="material-icons" aria-hidden="true">where_to_vote</em>
        Servicio al cliente
      </a>
    </li>

    <div class="c-nav_btns">
      <a appDebounceClick id="Header_PTEC-Ir A Main" title="Ir al portal público" href="#"
        class="u-btn u-btn--blue u-btn--blueu-btn--small u-btn--icon buttom-width-100" (click)="toogleMenu()">
        <!--<em class="material-icons">navigate_next</em>-->
        Ir al portal público
      </a>
    </div>
  </ul>
</div>
